var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-echart-doughnut',{staticStyle:{"width":"100%"},attrs:{"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }